export function UnlinkedInterface() {
  return (
    <svg
      width="119"
      height="122"
      viewBox="0 0 119 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.11488"
        y="0.959121"
        width="116.77"
        height="119.982"
        rx="3.35803"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <rect
        x="19.3545"
        y="23.644"
        width="73.617"
        height="3.71803"
        rx="1.85901"
        fill="#D7D3C9"
      />
      <rect
        x="19.3467"
        y="71.978"
        width="80.3094"
        height="3.71803"
        rx="1.85901"
        fill="#D7D3C9"
      />
      <rect
        x="19.3467"
        y="80.1558"
        width="54.2832"
        height="3.71803"
        rx="1.85901"
        fill="#D7D3C9"
      />
      <rect x="36" y="99.9507" width="47" height="13" rx="6.5" fill="#B5B2AA" />
      <path
        d="M23.6323 48.6141H35.6101C36.5551 48.6141 37.3212 47.8248 37.3212 46.8512V34.5104C37.3212 33.5368 36.5551 32.7475 35.6101 32.7475H23.6323C22.6873 32.7475 21.9212 33.5368 21.9212 34.5104V46.8512C21.9212 47.8248 22.6873 48.6141 23.6323 48.6141ZM23.6323 48.6141L33.0434 38.9178L37.3212 43.3253M27.9101 37.5956C27.9101 38.3259 27.3355 38.9178 26.6267 38.9178C25.918 38.9178 25.3434 38.3259 25.3434 37.5956C25.3434 36.8654 25.918 36.2734 26.6267 36.2734C27.3355 36.2734 27.9101 36.8654 27.9101 37.5956Z"
        stroke="#B5B2AA"
        strokeWidth="2.48889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
